import _ from "lodash";

import { Nodes } from "@/pages/scenario-builder/utils";

import { InvestmentRating, RatingToInvestmentRatingMap } from "../constants/maps";
import { GraphDataDTO } from "../types/dto";
import { SaturationCurve } from "../types/saturationCurve";

export const transformSaturationCurvesToGraphData = (
  saturationCurves: SaturationCurve[] = [],
  nodes: Nodes
): GraphDataDTO[] =>
  saturationCurves.map((saturationCurve) => {
    const {
      id,
      curveTypes,
      color,
      secondaryColor,
      curveValue,
      nodeUUID,
      rating,
      geography,
      channel,
      product,
      category,
      maxEfficiency,
      activeWeeks,
      spend,
      brand,
      revenue,
      channelLabel,
      lowerBound,
      upperBound,
      roi,
      roas,
      units,
    } = saturationCurve;

    const investmentRating =
      (rating && RatingToInvestmentRatingMap[rating]) || InvestmentRating.INSUFFICIENT_DATA;

    let nodeId = nodeUUID;
    if (!nodeUUID) {
      const defaultNode = nodes
        .getNodes()
        .find(
          (node) =>
            node.node.brand === brand &&
            node.node.product === product &&
            node.node.category === category
        );
      nodeId = defaultNode?.node.uuid ?? "";
    }

    const nodeNames = nodes.getNodeAndAncestors(nodeId).map((node) => node.warchestNode.name);

    return {
      id: id,
      color,
      secondaryColor,
      nodeUUID,
      curveTypes: curveTypes,
      curveValue,
      rating: investmentRating,
      geography,
      channel,
      channelLabel,
      product,
      category,
      activeWeeks,
      spend,
      revenue,
      brand,
      maxEfficiency,
      lowerBound,
      upperBound,
      nodeNames,
      roi,
      roas,
      units,
    };
  });
